import { Outlet } from "react-router";

import { ThemeInitializer } from "@/components/features/settings/ThemeInitializer";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { TooltipProvider } from "@/components/ui/tooltip";
import { usePageTitle } from "@/hooks/ui/usePageTitle";
import { AppSidebar } from "@/layouts/AppSidebar";

export default function Layout() {
	usePageTitle();
	return (
		<TooltipProvider>
			<SidebarProvider className="glass-bg-mesh h-screen overflow-hidden">
				<ThemeInitializer />
				<AppSidebar />
				<SidebarInset className="flex flex-col overflow-hidden bg-gray-cool-150 dark:bg-transparent">
					<div className="flex-1 overflow-y-auto">
						<div className="mx-auto">
							<Outlet />
						</div>
					</div>
				</SidebarInset>
			</SidebarProvider>
		</TooltipProvider>
	);
}
